export const ChatBotMessages = {
  copy: 'Copy',
  copied: 'Copied',
  copyCode: 'Copy Code',
  copyFailed: 'Copy Failed',
}
